// Verbatim markup lifted from the legacy public/index.html, split into the two
// regions the shell hosts as panels. React renders these ONCE as opaque leaves
// (dangerouslySetInnerHTML, never re-rendered); the legacy app.js then drives
// them by id exactly as it always did. Keeping the ids/classes byte-identical
// is what lets the 6.6k-line engine keep working untouched.

export const CONTENT_HTML = `
<!-- THE MISSIONS COLUMNS LIVE IN REACT (2026-08-23): the census sidebar and
     the view column are shell SplitView panels in App.jsx — the kit's one
     sidebar component. The engine announces data (missions:census /
     missions:page / missions:view); nothing column-shaped stands here. -->
<div class="content">
  <!-- Missions — THE WALL IS RIPPED OUT (owner call 2026-08-23): this page is
       the section's EMPTY STATE only (the first-mission door). Every populated
       path lands on a mission page; the sidebar is the census. NOT active at
       boot — nothing paints here before the entry mission opens, so a refresh
       never flashes the old index. -->
  <div class="page" id="page-missions">
    <div id="missions-body"></div>
    <button class="new-mission-fab" id="new-mission-fab" type="button" title="New mission" aria-label="New mission">+</button>
  </div>

  <!-- Now — no topline, the missions index's grammar: the queue opens flush at
       the page top. The rail cell already says which page you are on, and the
       buckets (overdue / today / this week) carry the wayfinding from there. -->
  <!-- Now — REACT'S PAGE (src/pages/Now.jsx portals in here) -->
  <div class="page" id="page-now"></div>

  <!-- Mission detail — REACT'S PAGE (src/pages/Mission.jsx portals in here;
       the outliner + signals paint into its leaf divs from the engine) -->
  <div class="page" id="page-mission"></div>

  <!-- Builder — mission builder / editor -->
  <div class="page" id="page-builder">
    <div class="topline">
      <div class="breadcrumb"><span class="back" onclick="navToMissions()">← Missions</span><span> · Builder</span></div>
      <div class="date-tag" id="builder-mode-tag">new mission</div>
    </div>
    <!-- the form is REACT'S (src/pages/Builder.jsx portals in after this topline) -->
  </div>

  <!-- Schedule — REACT'S PAGE (src/pages/Schedule.jsx portals in here; the
       legacy event/availability editors mount into its #sched-form-host) -->
  <div class="page" id="page-schedule"></div>

  <!-- Manage — the workspace's own furniture (tags today). Not a view onto
       missions; the things you define ONCE and then use across all of them. -->
  <!-- Manage — REACT'S PAGE (src/pages/Manage.jsx portals in here) -->
  <div class="page" id="page-manage"></div>

  <!-- Lookback — REACT'S PAGE (src/pages/Lookback.jsx portals in here) -->
  <div class="page" id="page-lookback"></div>
</div>
`;

export const CHAT_HTML = `
<aside class="chat-panel" id="chat-panel">
  <!-- The header is React now: AgentPanel renders the shell <BlockTitle>
       (name + new-chat cell + chevron close) above this legacy body. -->
  <div class="chat-body thread-messages" id="chat-body"></div>
  <!-- The shell chat register's composer band (@ofself/shell/chat.css):
       [input | send] docked in the block foot, flush to the panel bottom. -->
  <div class="chat-input block__foot block__foot--flow">
    <div class="composer-shell block__foot-surface">
      <div class="message-input-container">
        <div class="composer-row">
          <div class="input-wrapper">
            <div class="input-row">
              <div class="editor-wrap">
                <textarea id="chat-input" class="message-textarea" placeholder="Ask anything" autocomplete="off" rows="1"></textarea>
              </div>
            </div>
          </div>
          <button class="send-btn" id="chat-send" title="Send" aria-label="Send">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</aside>
`;

// (SHEET_HTML retired — the sheet is React: src/pages/Sheet.jsx.)
